
import { Product, NavLink } from './types';

export const NAV_LINKS= [
  { label: 'Home', href: '#' },
  { label: 'Products', href: '#products' },
  { label: 'About Us', href: '#about' },
  { label: 'Vitality Guide', href: '#guide' },
  { label: 'Contact', href: '#contact' },
];

export const PRODUCTS= [
  {
    id: 'body-boost',
    name: 'AMS Body Boost',
    tagline: 'Fuel Your Power',
    description: 'A potent formula designed to increase testosterone levels, support vitality, and enhance muscle strength.',
    imageUrl: 'https://sunriseindia.co.in/temp/images/B- (1).png',
    benefits: ['Increases Testosterone', 'Supports Vitality', 'Enhances Muscle Strength']
  },
  {
    id: 'cordyceps',
    name: 'AMS Cordyceps',
    tagline: 'Unlock Your Inner Strength',
    description: 'Experience the pure power of Himalayan Cordyceps to boost energy and stamina naturally.',
    imageUrl: 'https://sunriseindia.co.in/temp/images/C- (1).png',
    benefits: ['Boosts Energy', 'Enhances Libido', 'Natural & Pure']
  },
  {
    id: 'dhatu-paushtik',
    name: 'Dhatu Paushtik',
    tagline: 'Ancient Wisdom, Modern Wellness',
    description: 'A traditional Ayurvedic blend to nourish your inner strength and restore balance.',
    imageUrl: 'https://sunriseindia.co.in/temp/images/D- (1).png',
    benefits: ['Supports Digestion', 'Boosts Immunity', 'Enhances Resilience']
  },
  {
    id: 'liv-ams',
    name: 'LIV-AMS',
    tagline: 'Reclaim Your Health',
    description: 'Complete liver support and detox formula to protect and regenerate your vital cells.',
    imageUrl: 'https://sunriseindia.co.in/temp/images/L- (1).png',
    benefits: ['Natural Detox', 'Better Digestion', 'Cellular Defense']
  },
  {
    id: 'tila-oil',
    name: 'Tila Oil',
    tagline: 'Ignite Your Inner Fire',
    description: 'Authentic Ayurvedic formula for external application to improve local blood supply and stamina.',
    imageUrl: 'https://sunriseindia.co.in/temp/images/T- (1).png',
    benefits: ['Improves Blood Flow', 'Enhances Pleasure', 'Boosts Confidence']
  },
  {
    id: 'shilajit',
    name: 'AMS Shilajit',
    tagline: 'Unlock Your True Potential',
    description: 'Pure, purified Shilajit sourced from high altitudes for ultimate power and endurance.',
    imageUrl: 'https://sunriseindia.co.in/temp/images/S- (1).png',
    benefits: ['Power & Vigor', 'Elevates Mood', 'Pure Purified Extract']
  },
  {
    id: 'testo-boost',
    name: 'AMS Testo Boost',
    tagline: 'Unleash Your Potential',
    description: 'Advanced peak performance formula for energy, stamina, and strength.',
    imageUrl: 'https://sunriseindia.co.in/temp/images/T- (1).png',
    benefits: ['Peak Performance', 'Increased Energy', 'Enhanced Strength']
  }
];

export const HERO_IMAGE = 'https://sunriseindia.co.in/temp/images/3.jpg';
